import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

export interface LabelValue {
  label: string;
  value: string;
}
export interface LevelsByZone {
  public: LabelValue[];
  passenger: LabelValue[];
}
export interface DetailPageData {
  zones: LabelValue[];
  levels: LevelsByZone;
}
export interface DetailPageLabelData {
  searchText: string;
  publicAreaText: string;
  passengerAreaText: string;
  categoryText: string;
  zoneText: string;
  levelText: string;
}
export interface DetailPage {
  data: DetailPageData;
  labelData: DetailPageLabelData;
}
export interface FieldContent {
  data: Record<string, unknown>;
  labelData: Record<string, unknown>;
  detailPage: DetailPage;
}
export interface DocumentDetailsResponse {
  id: number;
  field_content_en: FieldContent;
  field_content_ms: FieldContent;
  field_content_zh: FieldContent;
  field_content_html_english: string;
  field_page_content_airport: string;
  field_page: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

// edit api call
const fetchLandingPageContentDetails = async (airport: string): Promise<any> => {
  if (!airport) {
    return;
  }
  const response: any = await passengerCMSApi.get(
    `/api/page-content/all-fields?pageName=shop-dine-services%2Fshop&airport=${airport}`
  );
  console.log("labelsDataaaaaa --hooks", response);
  return response?.data[0];
};

const useLabelsDataDetails = (
  airport?: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["landingPageContenDetails", airport],
      enabled: false,
      queryFn: () => {
        return fetchLandingPageContentDetails(airport);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useLabelsDataDetails };
